import { render, staticRenderFns } from "./EventsSection.vue?vue&type=template&id=7c31aae2&scoped=true"
import script from "./EventsSection.vue?vue&type=script&lang=js"
export * from "./EventsSection.vue?vue&type=script&lang=js"
import style0 from "./EventsSection.vue?vue&type=style&index=0&id=7c31aae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c31aae2",
  null
  
)

export default component.exports